import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const Footer = () => {
  return (
    <footer className="bg-secondary py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">OMN SEO Tools</h3>
            <p className="text-sm text-muted-foreground">
              info@omnseotools.ch
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm hover:text-primary transition-colors">
                  Startseite
                </a>
              </li>
              <li>
                <a href="/#tools" className="text-sm hover:text-primary transition-colors">
                  Tools
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm hover:text-primary transition-colors">
                  Über Uns
                </a>
              </li>
              <li>
                <a href="/contact" className="text-sm hover:text-primary transition-colors">
                  Kontakt
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-sm hover:text-primary transition-colors">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="/terms" className="text-sm hover:text-primary transition-colors">
                  Nutzungsbedingungen
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-lg font-semibold mb-4">Newsletter</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Bleiben Sie auf dem Laufenden – Abonnieren Sie unseren Newsletter!
            </p>
            <form className="flex gap-2">
              <Input
                type="email"
                placeholder="Ihre E-Mail-Adresse"
                className="max-w-xs"
              />
              <Button type="submit" variant="default">Anmelden</Button>
            </form>
          </div>
        </div>
      </div>
    </footer>
  );
};